import { toast } from 'react-hot-toast';

class Toastify {

    error(err) {
        toast.error(<div data-cy="toast-error">{err}</div>, { duration: 5000, position: "top-right" });
    }

    info(info, props) {
        toast(<div data-cy="toast-info">{info}</div>, {
            icon: 'ℹ️',
            duration: 5000,
            position: "bottom-right",
            ...props,
        });
    }

    success(msg) {
        toast.success(<div data-cy="toast-success">{msg}</div>, { duration: 5000, position: "top-right" });
    }

    warn(err) {
        toast(<div data-cy="toast-warn">{err}</div>, {
            icon: '⚠️',
            duration: 5000,
            position: "top-right",
            style: { textAlign: 'center' }
        });
    }

}

export default new Toastify();
